module.exports = __webpack_public_path__ + "img/icon.68c238cf.png";